import { gql } from 'apollo-angular';

import {
  ASSET_FRAGMENT,
  CART_FRAGMENT,
  ERROR_RESULT_FRAGMENT,
} from '../../graphql/fragments.graphql';

export const GET_PRODUCT_DETAIL = gql`
  query GetProductDetail($slug: String!) {
    product(slug: $slug) {
      id
      name
      description
      slug
      variants {
        id
        name
        stockLevel
        options {
          code
          name
        }
        price
        priceWithTax
        sku
        featuredAsset {
          ...Asset
        }
      }
      featuredAsset {
        ...Asset
      }
      assets {
        ...Asset
      }
      attributes {
        languageCode
        name
        code
        value
      }
      customAttributes {
        manufacturer {
          id
          name
          code
          asset {
              id
              preview
              focalPoint {
                x
                y
              }
          }

        }
        productAttributes {
          languageCode
          name
          code
          value
        }
        stockLevel
      }
      collections {
        id
        slug
        breadcrumbs {
          id
          name
          slug
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
